import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const EarningsInsightWrapper = styled.div<{
  $isPreview: boolean;
  $isClickable: boolean;
}>`
  width: fit-content;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  ${borderRadius.r2};
  background-color: ${({ $isPreview }) =>
    $isPreview
      ? 'var(--surface-decorative-purple-default)'
      : 'var(--surface-decorative-teal-default)'};
  ${({ $isClickable }) =>
    $isClickable &&
    css`
      &:hover {
        transform: scale(1.05);
        cursor: pointer !important;
      }
    `}
`;

export const EarningsInsightLabel = styled.span<{ $isPreview: boolean }>`
  ${typographyV2.uiXs};
  font-family: var(--font-nort);
  color: ${({ $isPreview }) =>
    $isPreview
      ? 'var(--text-decorative-purple)'
      : 'var(--text-decorative-teal)'};
`;
